var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:(`height: 100%; z-index: 0; ${_vm.contentStyle}`)},[(_vm.hasTitle)?_c('v-card-title',{style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.widget.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }